import { navlinks as dashboard } from "./dahsboard";
import { navlinks as posts } from "./posts";
import { navlinks as markers } from './markers';

export const NavItems = { 
  items: [ dashboard, posts, markers] 
};
